import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';
import ComponentArrasteSolteQuestion from './ComponentArrasteSolteQuestion';

interface IComponentArrasteSolte {
    codigo: number;
    title: string;
    questions: ComponentArrasteSolteQuestion[];
}

class ComponentArrasteSolte extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    title: string = '';

    questions: ComponentArrasteSolteQuestion[] = [];

    fromJSON(json: IComponentArrasteSolte, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.title = json.title;
        this.questions = json.questions;

        return this;
    }
}

export default ComponentArrasteSolte;
